import React from "react";
import { motion } from "framer-motion";
import { TbSun, TbMoon } from "react-icons/tb";
import style from "../styles/themeToggle.module.css";

const ThemeToggle = ({ theme, toggle }) => {
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      className={style.toggle}
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      <motion.span
        className={style.knob}
        animate={{ x: isDark ? 26 : 0 }}
        transition={{ type: "spring", stiffness: 500, damping: 32 }}
      />
      <span className={`${style.icon} ${!isDark ? style.active : ""}`}>
        <TbSun />
      </span>
      <span className={`${style.icon} ${isDark ? style.active : ""}`}>
        <TbMoon />
      </span>
    </button>
  );
};

export default ThemeToggle;
